<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="12">
          <v-card class="rounded-xl">
            <v-overlay absolute style="opacity: 0.8" :value="isMainLoading">
              <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </v-overlay>

            <v-card-title>
              <v-row style="justify-content: space-between">
                <v-card-title class="title-displays"> Unidades </v-card-title>
                <v-card-title>
                  <v-btn v-if="isEnabledAction('newUnit')" right @click="openUnit('signup')" color="primary" text>
                    <v-icon> add </v-icon>
                    Nova Unidade
                  </v-btn>
                </v-card-title>
              </v-row>
            </v-card-title>
            <v-card style="overflow: hidden">
              <v-row style="justify-content: space-between">
                <v-text-field style="width:80%; padding:1em" class="px-4" prepend-icon="search" label="Busca"
                  v-model="searchText"></v-text-field>
                <v-select hint="Buscar nessa coluna" persistent-hint style="width:20%; padding: 1em"
                  v-model="columnToSeach" :items="columnsToChoose" return-object single-line></v-select>
              </v-row>

              <v-data-table :headers="headers" :items="getUnitsLocal" no-data-text="Sem unidades para exibir"
                :footer-props="{
                  'items-per-page-options': [5, 10, 20, 30]
                }" :page.sync="page" :items-per-page="10" disable-sort>
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(unit, i) in items" :key="i" style="height: 100%;color: #1976d2">
                      <td @click="openUnit('view', unit)">
                        <v-img :src="getImage(unit.id_client)" contain max-height="80px" max-width="220px"
                          min-width="220px">
                        </v-img>
                      </td>
                      <td @click="openUnit('view', unit)">
                        <v-card-text class="units-table-names">{{ unit.name_client }} / {{ unit.name }}</v-card-text>
                      </td>
                      <td @click="openUnit('view', unit)" v-if="isAdmin">
                        <v-card-text class="units-table-names">{{ unit.franchiseeName }}</v-card-text>
                      </td>
                      <td @click="openUnit('view', unit)">
                        <v-card-text class="units-table-names">{{ getRegistration(unit.matricula) }}</v-card-text>
                      </td>
                      <td @click="openUnit('view', unit)">
                        <v-card-text class="units-table-names">{{ getInvoicingGroup(unit.grupoFaturamento)
                          }}</v-card-text>
                      </td>
                      <td @click="openUnit('view', unit)">
                        <v-card-text class="units-table-names">{{ getAddress(unit.address) }}</v-card-text>
                      </td>
                      <td style="width: 100px;">
                        <v-card-text style="white-space: normal; padding: 0;">
                          <span style="display: flex; align-items: center; gap: 4px;">
                            <v-icon small color="primary" class="mr-2" @click="openUnit('edit', unit)" v-if="isEnabledAction('editUnit')">
                              mdi-pencil
                            </v-icon>
                            <v-icon small color="error" @click="confirmDeleteUnit(unit)" v-if="isEnabledAction('deleteUnit')">
                              mdi-delete
                            </v-icon>
                          </span>
                        </v-card-text>
                      </td>

                    </tr>

                  </tbody>
                </template>


              </v-data-table>

            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <!-- Modal para a visualização dos dados da unidade -->
    <v-dialog v-model="openModal" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Unidade </v-card-title>

        <!-- Conteúdo das informações da unidade -->
        <v-card flat>
          <v-card-text>
            Descricao {{ this.id_client }} / {{ this.index_unit }}
          </v-card-text>
        </v-card>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="openModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent max-width="1500" v-model="dialog" v-if="dialog">
      <v-card>
        <v-card-title class="primary lighten white--text">{{
          formTitle
        }}
          <v-spacer></v-spacer>

          <v-btn class="litte white--text" text @click="close">

            <v-icon white>mdi-window-close</v-icon>

          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tabUnit">
            <v-tab v-for="selectedTab in FormColumns" :key="selectedTab">
              {{ selectedTab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabUnit">
            <v-tab-item key="1">
              <v-form ref="form" v-model="validForm" lazy-validation>
                <v-row style="margin-bottom: -10px;">
                  <v-col sm="3" cols="12">
                    <v-tooltip bottom>

                      <template v-slot:activator="{ on, attrs }">
                        <v-img v-bind="attrs" v-on="on" :src="getCurrentImage" contain style="
                            height: 143px;                           
                            margin-top: 20px;
                            border: solid blue thin;
                            border-radius: 15px;
                          " :disabled="isActiveOnlyView" />
                        <!-- <v-img v-bind="attrs" v-on="on" :src="getCurrentImage" contain style="
                            height: 143px;                           
                            margin-top: 20px;
                            border: solid blue thin;
                            border-radius: 15px;
                          " :disabled="isActiveOnlyView" @click="() => pickFile()" /> -->
                        <!-- <input type="file" id="get_image" ref="get_image" accept="image/*" style="display: none"
                          @input="onFilePicked" /> -->
                      </template>
                      <!-- <span>Clique para selecione uma imagem!</span> -->
                    </v-tooltip>
                  </v-col>
                  <v-col sm="9" cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-select @change="selectUser" :loading="usersLoadings.getData" :items="usersByRank"
                          item-text="name" item-value="id" :label="isEdit || isActiveOnlyView
                            ? 'Usuário Selecionado'
                            : 'Selecione o Usuário'
                            " :disabled="isActiveOnlyView" v-model="editedItem.id_client"
                          :readonly="isActiveOnlyView || usersLoadings.getData" :rules="rulesRequired"></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="CNPJ / CPF" v-model="clientName" :disabled="isActiveOnlyView"
                          :readonly="true" :rules="rulesRequired">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field outlined label="Nome" prepend-inner-icon="apartment" v-model="editedItem.name"
                          :disabled="isActiveOnlyView" :readonly="isActiveOnlyView" :rules="rulesUnitName">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-divider />
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-row>
                      <v-col sm="8" cols="12" style="
                          background: #1976D205;
                          border-radius: 15px;
                          border: 1px solid #ccc!important;
                      ">
                        <h2 style="text-align: center;padding-bottom: 10px">Dados da Concessionária</h2>
                        <v-divider />
                        <v-row>
                          <v-col sm="6" cols="12">
                            <v-text-field background-color="white" outlined v-model="editedItem.matricula"
                              label="Matrícula" type="number" :disabled="isActiveOnlyView"
                              :readonly="isActiveOnlyView"></v-text-field>
                          </v-col>
                          <v-col sm="6" cols="12">
                            <v-select background-color="white" outlined :items="waterAuthorities" label="Concessionária"
                              v-model="editedItem.concessionaria" :disabled="isActiveOnlyView"
                              :readonly="isActiveOnlyView" :rules="rulesRequired">
                            </v-select>
                          </v-col>
                          <v-col sm="6" cols="12">
                            <v-select background-color="white" outlined :items="[
                              'Residencial',
                              'Comercial',
                              'Industrial',
                              'Pública',
                            ]" label="Grupo de Faturamento" v-model="editedItem.grupoFaturamento"
                              :disabled="isActiveOnlyView || editedItem.concessionaria == 'Sem Concessionária' || editedItem.concessionaria == null"
                              :readonly="isActiveOnlyView"
                              :rules="editedItem.concessionaria == 'Sem Concessionária' || editedItem.concessionaria == null ? [] : rulesRequired">
                            </v-select>
                          </v-col>

                        </v-row>
                      </v-col>

                      <v-col sm="4" cols="12" style="
                          background: #1976D205;
                          border-radius: 15px;
                          border: 1px solid #ccc!important;
                      ">
                        <h2 style="text-align: center;padding-bottom: 10px">Tipo de Consumo</h2>
                        <v-divider />
                        <v-row>
                          <v-col :cols="isActiveWaterTarrifsTypes ? 6 : 12">
                            <v-select :rules="rulesRequired" background-color="white" outlined
                              :items="waterTariffsTypes" label="Água" v-model="editedItem.tarrifsTypes.water.tariffType"
                              :disabled="isActiveOnlyView" :readonly="isActiveOnlyView">
                            </v-select>
                          </v-col>
                          <v-col cols="6" v-if="isActiveWaterTarrifsTypes ? true : false">
                            <v-text-field :rules="rulesRequired" background-color="white" outlined label="Valor"
                              type="number" suffix="m³" v-model="editedItem.tarrifsTypes.water.value" :disabled="editedItem.tarrifsTypes.water.tariffType == 'Fixo' && action != 'view'
                                ? false
                                : true" :readonly="isActiveOnlyView">
                            </v-text-field>
                          </v-col>
                          <v-col :cols="isActiveViewSewerTarrifsTypes ? 6 : 12">
                            <v-select :rules="rulesRequired" background-color="white" outlined
                              :items="sewerTariffsTypes" label="Esgoto"
                              v-model="editedItem.tarrifsTypes.sewer.tariffType" :disabled="isActiveOnlyView"
                              :readonly="isActiveOnlyView">
                            </v-select>
                          </v-col>
                          <v-col cols="6" v-if="isActiveViewSewerTarrifsTypes ? true : false">
                            <v-text-field :rules="editedItem.tarrifsTypes.sewer.tariffType == 'Sem Esgoto' ? [] : rulesRequired" background-color="white" outlined label="Valor"
                              type="number" suffix="m³" v-model="editedItem.tarrifsTypes.sewer.value" :disabled="editedItem.tarrifsTypes.sewer.tariffType == 'Fixo' && action != 'view'
                                ? false
                                : true" :readonly="isActiveOnlyView">
                            </v-text-field>
                          </v-col>
                        </v-row>

                      </v-col>

                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-tab-item>
            <v-tab-item key="2">
              <v-row>
                <v-col cols="12">
                  <h2 style="color: grey">Endereço</h2>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="CEP" v-mask="'##.###-###'" :disabled="isActiveOnlyView"
                    v-model="editedItem.address.cep" :readonly="isActiveOnlyView" @input="handleCEPChange">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Logradouro" v-model="editedItem.address.logradouro"
                    :disabled="isActiveOnlyView" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Número" type="number" v-model="editedItem.address.numero"
                    :disabled="isActiveOnlyView" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Complemento" v-model="editedItem.address.complemento"
                    :disabled="isActiveOnlyView" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Bairro" v-model="editedItem.address.bairro" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Cidade" v-model="editedItem.address.cidade" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-select outlined label="UF" :items="ufList" v-model="editedItem.address.uf"
                    :disabled="isActiveOnlyView" :readonly="isActiveOnlyView">
                  </v-select>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Latitude" v-model="editedItem.address.lat" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Longitude" v-model="editedItem.address.lng" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>

              </v-row>
            </v-tab-item>
            <v-tab-item key="3">
              <v-row>
                <v-col cols="12">
                  <h2 style="color: grey">Dados Extras</h2>
                </v-col>

                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Poço" v-model="editedItem.poco" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>

                <v-col cols="3" md="3" sm="6">
                  <v-text-field outlined label="Quantidade de Poços" type="number" v-model="editedItem.qtdPocos"
                    :disabled="!editedItem.poco" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>

                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Tratamento de Efluentes" :disabled="isActiveOnlyView"
                    v-model="editedItem.tratamentoEfluentes" :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>

                <v-col cols="3" md="3" sm="6">
                  <v-select outlined label="Efluentes Tratados" :items="efluentesTratadosTypes"
                    v-model="editedItem.efluentesTratados" :disabled="!editedItem.tratamentoEfluentes"
                    :readonly="isActiveOnlyView">
                  </v-select>
                </v-col>
                <v-col cols="12" md="12" sm="1"></v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Caminhão Pipa" :disabled="isActiveOnlyView" v-model="editedItem.caminhaoPipa"
                    :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>


                <v-col cols="4" md="4" sm="6">
                  <v-text-field outlined label="Volume dos Caminhões" type="number" suffix="m³"
                    v-model="editedItem.volCaminhoes" :disabled="!editedItem.caminhaoPipa" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="5" md="5" sm="6">
                  <v-text-field outlined label="Qtd. de Caminhões/Mês" type="number" v-model="editedItem.qtdCaminhoes"
                    :disabled="!editedItem.caminhaoPipa" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="12" sm="1"></v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Bomba de Recalque" v-model="editedItem.bombaRecalque" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-text-field outlined label="Qtd. de Bombas de Recalque" type="number"
                    v-model="editedItem.qtdBombasRecalque" :disabled="!editedItem.bombaRecalque"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="2" sm="6">
                  <v-text-field outlined label="Potência" type="number" suffix="CV"
                    v-model="editedItem.potenciaBombasRecalque" :disabled="!editedItem.bombaRecalque"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="2" sm="6">
                  <v-text-field outlined label="Horas de Uso/dia" type="number" suffix="h"
                    v-model="editedItem.horasPorDiaBombasRecalque" :disabled="!editedItem.bombaRecalque"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="2" sm="6">
                  <v-text-field outlined label="Preço Médio do kWh" type="number" prefix="R$"
                    v-model="editedItem.kwhMedioRecalque" :disabled="!editedItem.bombaRecalque"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="12" sm="1"></v-col>

                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Bomba de Poço" v-model="editedItem.bombaPoco" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-text-field outlined label="Qtd. de Bombas de Poço" type="number" v-model="editedItem.qtdBombasPoco"
                    :disabled="!editedItem.bombaPoco" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="2" sm="6">
                  <v-text-field outlined label="Potência" type="number" suffix="CV"
                    v-model="editedItem.potenciaBombasPoco" :disabled="!editedItem.bombaPoco"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="2" sm="6">
                  <v-text-field outlined label="Horas de Uso/dia" type="number" suffix="h"
                    v-model="editedItem.horasPorDiaBombasPoco" :disabled="!editedItem.bombaPoco"
                    :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="2" sm="6">
                  <v-text-field outlined label="Preço Médio do kWh" type="number" prefix="R$"
                    v-model="editedItem.kwhMedioPoco" :disabled="!editedItem.bombaPoco" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="12" sm="1"></v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Aquecimento a Gás" :disabled="isActiveOnlyView" v-model="editedItem.aquecimentoGas"
                    :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>
                <v-col cols="3" md="3" sm="6">

                  <v-radio-group outlined label="Tipo do Gás" :disabled="!editedItem.aquecimentoGas"
                    v-model="editedItem.tipoGas">
                    <v-radio :key="1" label="Gás Natural" value="Gás Natural" :readonly="isActiveOnlyView"></v-radio>
                    <v-radio :key="2" label="GLP" value="GLP" :readonly="isActiveOnlyView"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-text-field outlined label="Consumo Mensal" type="number" :suffix="editedItem.tipoGas == 'Gás Natural' ? 'm³' : 'kg'
                    " v-model="editedItem.consumoGas" :disabled="!editedItem.aquecimentoGas" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <!-- v-if="editedItem.aquecimentoGas && editedItem.tipoGas" -->
                <v-col cols="3" md="3" sm="6">
                  <v-text-field outlined label="Preço" type="number" :suffix="editedItem.tipoGas == 'Gás Natural'
                    ? 'reais/m³'
                    : 'reais/kg'
                    " v-model="editedItem.precoGas" :disabled="!editedItem.aquecimentoGas" :readonly="isActiveOnlyView">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="12" sm="1"></v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-checkbox label="Ranking" v-model="editedItem.ranking" :disabled="isActiveOnlyView"
                    :readonly="isActiveOnlyView">
                  </v-checkbox>
                </v-col>
                <v-col cols="3" md="3" sm="6">
                  <v-radio-group outlined label="Tipo do Ranking" :disabled="!editedItem.ranking"
                    v-model="editedItem.tipoRanking">
                    <v-radio :key="1" label="por Consumo" value="por Consumo" :readonly="isActiveOnlyView"></v-radio>
                    <v-radio :key="2" label="por Ocorrências" value="por Ocorrências"
                      :readonly="isActiveOnlyView"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="12" sm="1"></v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="4">
              <v-row>
                <v-col cols="12">
                  <v-dialog v-model="sectorDialog" v-if="sectorDialog" max-width="700">
                    <v-card>
                      <v-card-title class="text-h5">
                        {{ flagEditModem ? "Editar Setor" : "Adicionar Setor" }}
                      </v-card-title>

                      <v-card-text>
                        <v-form ref="sectorForm" v-model="validSectorForm" lazy-validation>
                          <v-row>
                            <v-col cols="8">
                              <v-text-field outlined label="Nome do Setor" v-model="newSectorData.name"
                                :rules="rulesRequired" />
                            </v-col>
                            <v-col cols="4">
                              <v-select v-model="newSectorData.waterSupplyType" outlined :items="waterSupplyTypeList"
                                label="Tipo" :rules="rulesRequired" />
                            </v-col>
                            <v-col cols="12">
                              <v-autocomplete 
                              v-model="newSectorData.id_modem" :disabled="modensWithouUnitLoading"
                                @change="checkPortsByModem"
                                :loading="modensWithouUnitLoading" :items="modensWithouUnit" outlined label="Modem"
                                item-text="name" item-value="id" style="margin-top: 5px;min-width: 200px"
                                :rules="rulesRequired" />
                            </v-col>
                            <v-col cols="6" v-if="newSectorData.waterSupplyType === 'WELL' || newSectorData.waterSupplyType === 'DEALERSHIP'">
                              <v-autocomplete v-model="newSectorData.id_sensor" outlined
                                 label="Hidrômetro" :items="dataHydrometers" :rules="rulesRequired" 
                                 item-text="name"
                                 hide-details
                                 item-value="id"
                                />
                            </v-col>
                            <v-col cols="6" v-if="newSectorData.waterSupplyType === 'RESERVOIR'">
                              <v-autocomplete v-model="newSectorData.id_sensor" outlined
                                 label="Sonda" :items="dataWaterProbe" :rules="rulesRequired" 
                                 item-text="name"
                                 hide-details
                                 item-value="id"
                                />
                            </v-col>
                            <v-col cols="6" v-if="newSectorData.waterSupplyType === 'RESERVOIR'">
                              <v-select v-model="newSectorData.port" outlined :items="[1,2,3]"
                                label="Porta" :rules="rulesRequired" />
                            </v-col>
                            <v-col cols="6" v-if="newSectorData.waterSupplyType === 'RESERVOIR'">
                              <v-text-field outlined label="Volume" v-model="newSectorData.reservoirVolume"
                                :rules="rulesRequired" />
                            </v-col>
                            <v-col cols="12" v-if="newSectorData.waterSupplyType === 'RESERVOIR'">
                              <v-subheader class="pl-0">
                                Altura Maxima do Reservatorio
                              </v-subheader>
                              <v-slider :rules="rulesRequired" v-model.number="newSectorData.reservoirMaxHeight" thumb-label="always" step="0.1"></v-slider>
                            </v-col>
                            <v-col cols="12" v-if="newSectorData.waterSupplyType === 'RESERVOIR'">
                              <v-subheader class="pl-0">
                                Altura Maxima da agua
                              </v-subheader>
                              <v-slider :rules="rulesRequired" v-model.number="newSectorData.reservoirHeight" thumb-label="always" step="0.1"></v-slider>
                            </v-col>
                            <v-col cols="12" v-if="newSectorData.waterSupplyType === 'RESERVOIR'">
                              <v-subheader class="pl-0">
                                Nivel Minimo
                              </v-subheader>
                              <v-slider :rules="rulesRequired" v-model.number="newSectorData.reservoirMinHeight" thumb-label="always" step="0.1"></v-slider>
                            </v-col>
                            <v-col cols="12">
                              <v-radio-group row label="Faturado?" v-model="newSectorData.invoiced" mandatory>
                                <v-radio label="Sim" :value="true"></v-radio>
                                <v-radio label="Não" :value="false"></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="darken-1" :disabled="sectorLoadings.save" text @click="closeSectorDialog()">
                          Cancelar
                        </v-btn>
                        <v-btn color="darken-1" :loading="sectorLoadings.save" text @click="saveSector()">
                          Salvar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-data-table :loading="sectorLoadings.getData" :headers="headersSector" :items="sectorsByUnitList"
                    item-key="id_modem" class="elevation-1" no-data-text="Sem setores para exibir" hide-default-footer
                    :items-per-page="itemsSectors">

                    <template v-slot:top>
                      <v-toolbar flat class="rounded-lg">
                        <v-toolbar-title>Setores</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" class="mb-2" text @click="insertSector()" :disabled="isActiveOnlyView || !editedItem.id">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.actions="{ item }">

                      <v-btn :loading="loadingSectors(item, sectorLoadings.delete)" elevation="2"
                        @click="editSector(item)" style="height: 30px;margin: 2px;"
                        :disabled="isActiveOnlyView || sectorLoadings.delete">
                        <v-icon color="primary" small>
                          edit
                        </v-icon>
                      </v-btn>
                      <v-btn :loading="loadingSectors(item, sectorLoadings.delete)" elevation="2"
                        @click="removeSector(item)" style="height: 30px;margin: 2px;" v-if="isAdmin"
                        :disabled="isActiveOnlyView || sectorLoadings.delete">
                        <v-icon color="primary" small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:item.invoiced="{ item }">
                      <v-simple-checkbox v-model="item.invoiced" disabled />
                    </template>
                    <template v-slot:item.waterSupplyType="{ item }">
                      {{ waterSupplyTypeSlug(item.waterSupplyType) }}
                    </template>
                    <template v-slot:item.hydrometerModel="{ item }">
                      {{ hydrometerModelsSlug(item) }}
                    </template>

                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="5">
              <Historics :dataMediaHistorico="editedItem.dataMediaHistorico" :unit="editedItem"
                :historicos="historicsByUnitId" :disabled="isActiveOnlyView"
                :baselineConfig="currentBaselineConfig"
                :save-installation-date="saveInstallationDateFromHistorics"
                @change="changeHistorics" />
            </v-tab-item>
            <v-tab-item key="6">
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="meta-kpi-card meta-kpi-card--primary">
                    <v-card-text class="meta-kpi-card__content">
                      <div class="meta-kpi-card__label">Média de consumo antes da Foz</div>
                      <div class="meta-kpi-card__value-row">
                        <span class="meta-kpi-card__value">{{ getAverageBeforeFoz }}</span>
                        <span class="meta-kpi-card__unit">M³</span>
                      </div>
                      <div class="meta-kpi-card__support">Consumo médio do periodo anterior a Foz</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="meta-kpi-card">
                    <v-card-text class="meta-kpi-card__content">
                      <div class="meta-kpi-card__label">Meta de economia</div>
                      <div class="meta-kpi-card__value-row">
                        <span class="meta-kpi-card__value">{{ getGoalEconomy }}</span>
                        <span class="meta-kpi-card__unit">M³</span>
                      </div>
                      <div class="meta-kpi-card__support">
                        Percentual em uso: {{ displayedMetaEconomia }}%
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="meta-kpi-card">
                    <v-card-text class="meta-kpi-card__content">
                      <div class="meta-kpi-card__label">Média de agua antes da Foz</div>
                      <div class="meta-kpi-card__value-row">
                        <span class="meta-kpi-card__value">{{ getAverageWaterBeforeFoz }}</span>
                        <span class="meta-kpi-card__unit">M³</span>
                      </div>
                      <div class="meta-kpi-card__support">Referência histórica de água</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="meta-kpi-card">
                    <v-card-text class="meta-kpi-card__content">
                      <div class="meta-kpi-card__label">Média de esgoto antes da Foz</div>
                      <div class="meta-kpi-card__value-row">
                        <span class="meta-kpi-card__value">{{ getAverageSewerBeforeFoz }}</span>
                        <span class="meta-kpi-card__unit">M³</span>
                      </div>
                      <div class="meta-kpi-card__support">Referência histórica de esgoto</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="!hasHistoricBefore">
                  <v-card outlined style="border-left: 5px solid #1976D2; background: #1976D210;">
                    <v-card-text style="color: #555; font-weight: 600;">
                      Funções de meta desabilitadas. A unidade precisa ter histórico antes da Foz.
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col sm="12" cols="12" style="
                  background: rgba(25, 118, 210, 0.02);
                  border-radius: 15px;
                  border: 1px solid rgb(204, 204, 204) !important;">
                  <h2 style="color: grey; padding: 10px;text-align: center;">BASELINE ATUAL</h2>
                  <v-divider />
                  <v-row class="baseline-summary-row">
                    <v-col cols="12" v-if="!editedItem.id">
                      <v-card outlined class="baseline-empty-card">
                        <v-card-text class="baseline-empty-text">
                          Salve a unidade para cadastrar, consultar e organizar o histórico de baselines.
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <template v-else-if="currentBaselineConfig">
                      <v-col cols="12" md="4">
                        <v-card outlined class="baseline-summary-card baseline-summary-card--primary">
                          <v-card-text class="baseline-summary-card__content">
                            <div class="baseline-card-label">Referência adotada</div>
                            <div class="baseline-card-chip">{{ getBaselineModeText(currentBaselineConfig.referenceMode) }}</div>
                            <div class="baseline-card-label" style="margin-top: 14px;">Meta de economia</div>
                            <div class="baseline-card-emphasis">{{ currentBaselineConfig.metaEconomia }}%</div>
                            <div class="baseline-card-label" style="margin-top: 12px;">Data de criação</div>
                            <div class="baseline-card-value">{{ formatBaselineDateTime(currentBaselineConfig.createdAt) }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card outlined class="baseline-summary-card">
                          <v-card-text class="baseline-summary-card__content">
                            <div class="baseline-card-label">Período de validade</div>
                            <div class="baseline-card-value baseline-card-value--lg">
                              {{ formatBaselineDate(currentBaselineConfig.validFrom) }} até {{ formatBaselineDate(currentBaselineConfig.validTo) }}
                            </div>
                            <template v-if="currentBaselineConfig.driver && currentBaselineConfig.driver.isEnabled">
                              <div class="baseline-card-label" style="margin-top: 14px;">Driver de referência</div>
                              <div class="baseline-card-value">{{ getDriverTypeText(currentBaselineConfig.driver.driverType) }}</div>
                              <div class="baseline-card-support">
                                Rótulo: {{ currentBaselineConfig.driver.driverLabel || '-' }}
                              </div>
                              <div class="baseline-card-support">
                                Unidade: {{ currentBaselineConfig.driver.driverUnitLabel || '-' }}
                              </div>
                            </template>
                            <template v-else>
                              <div class="baseline-card-label" style="margin-top: 14px;">Driver de referência</div>
                              <div class="baseline-card-value">Sem driver configurado</div>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card outlined class="baseline-summary-card">
                          <v-card-text v-if="normalizeReferenceMode(currentBaselineConfig.referenceMode) === 'fixedBaseline'" class="baseline-summary-card__content">
                            <div class="baseline-card-label">Baseline fixa atual</div>
                            <div class="baseline-metric-grid">
                              <div class="baseline-metric-box">
                                <div class="baseline-metric-box__label">Água</div>
                                <div class="baseline-metric-box__value">{{ currentBaselineConfig.fixedBaseline && currentBaselineConfig.fixedBaseline.water != null ? currentBaselineConfig.fixedBaseline.water : '-' }}</div>
                                <div class="baseline-metric-box__unit">m³</div>
                              </div>
                              <div class="baseline-metric-box">
                                <div class="baseline-metric-box__label">Esgoto</div>
                                <div class="baseline-metric-box__value">{{ currentBaselineConfig.fixedBaseline && currentBaselineConfig.fixedBaseline.sewer != null ? currentBaselineConfig.fixedBaseline.sewer : '-' }}</div>
                                <div class="baseline-metric-box__unit">m³</div>
                              </div>
                              <div class="baseline-metric-box">
                                <div class="baseline-metric-box__label">Ref. monetaria</div>
                                <div class="baseline-metric-box__value">{{ currentBaselineConfig.fixedBaseline && currentBaselineConfig.fixedBaseline.reference_economy != null ? currentBaselineConfig.fixedBaseline.reference_economy : '-' }}</div>
                                <div class="baseline-metric-box__unit">R$</div>
                              </div>
                            </div>
                            <template v-if="currentBaselineConfig.driver && currentBaselineConfig.driver.isEnabled && currentBaselineConfig.driver.driverReferenceValue != null && currentBaselineConfig.driver.driverReferenceValue !== ''">
                              <div class="baseline-driver-reference">
                                <div class="baseline-card-label">Valor de Referência do Driver</div>
                                <div class="baseline-driver-reference__name">{{ currentBaselineConfig.driver.driverLabel || 'Driver' }}</div>
                                <div class="baseline-driver-reference__value-row">
                                  <span class="baseline-driver-reference__value">{{ currentBaselineConfig.driver.driverReferenceValue }}</span>
                                  <span class="baseline-driver-reference__unit">{{ currentBaselineConfig.driver.driverUnitLabel || '-' }}</span>
                                </div>
                              </div>
                            </template>
                          </v-card-text>
                          <v-card-text v-else class="baseline-summary-card__content">
                            <div class="baseline-card-label">Baseline mensal atual</div>
                            <div class="baseline-card-value">Referência distribuída em 12 meses</div>
                            <div class="baseline-card-support">Este resumo mostra a baseline valida para hoje.</div>
                            <v-btn
                              color="primary"
                              text
                              class="baseline-monthly-action"
                              @click="openMonthlyBaselineView(currentBaselineConfig)"
                            >
                              Ver distribuicao mensal
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </template>
                    <v-col cols="12" v-else>
                      <v-card outlined class="baseline-empty-card">
                        <v-card-text class="baseline-summary-card__content">
                          <div class="baseline-card-label">Meta atual da unidade</div>
                          <div class="baseline-card-emphasis">{{ displayedMetaEconomia }}%</div>
                          <div class="baseline-card-support">Para utilizar do nosso novo recurso de metas, clique no botão "NOVA BASELINE".</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" v-if="editedItem.id">
                      <v-card outlined class="baseline-history-card">
                        <v-card-text class="baseline-history-card__content">
                          <div class="baseline-history-header">
                            <div>
                              <div class="baseline-card-label">Histórico de baselines</div>
                            </div>
                            <v-btn
                              color="primary"
                              text
                              :disabled="isActiveOnlyView || !canManageBaselineConfigs"
                              @click="openBaselineForm('create')"
                            >
                              Nova baseline
                            </v-btn>
                          </div>
                          <v-data-table
                            :headers="baselineHistoryHeaders"
                            :items="baselineConfigs"
                            :loading="baselineListLoading"
                            no-data-text="Nenhuma baseline encontrada"
                            disable-sort
                            class="baseline-history-table"
                          >
                            <template v-slot:item.timelineStatus="{ item }">
                              <v-chip
                                small
                                label
                                dark
                                :color="getBaselineTimelineStatus(item).color"
                              >
                                {{ getBaselineTimelineStatus(item).label }}
                              </v-chip>
                            </template>
                            <template v-slot:item.referenceMode="{ item }">
                              {{ getBaselineModeText(item.referenceMode) }}
                            </template>
                            <template v-slot:item.metaEconomia="{ item }">
                              {{ item.metaEconomia }}%
                            </template>
                            <template v-slot:item.validFrom="{ item }">
                              {{ formatBaselineDate(item.validFrom) }}
                            </template>
                            <template v-slot:item.validTo="{ item }">
                              {{ formatBaselineDate(item.validTo) }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{ formatBaselineDateTime(item.createdAt) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon small @click="openBaselineForm('view', item)">
                                <v-icon small color="primary">mdi-eye</v-icon>
                              </v-btn>
                              <v-btn
                                icon
                                small
                                :disabled="isActiveOnlyView || isPastBaselineConfig(item)"
                                @click="openBaselineForm('edit', item)"
                              >
                                <v-icon small color="primary">mdi-pencil</v-icon>
                              </v-btn>
                              <v-btn
                                icon
                                small
                                :disabled="isActiveOnlyView || isPastBaselineConfig(item)"
                                @click="confirmDeleteBaseline(item)"
                              >
                                <v-icon small color="error">mdi-delete</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <template v-if="false">
                  <v-row style="margin-top: 12px; padding: 0 12px;">
                    <v-col cols="12" md="4">
                      <v-select
                        outlined
                        :items="referenceModeOptions"
                        item-text="text"
                        item-value="value"
                        label="Modo de Referência"
                        v-model="editedItem.referenceMode"
                        :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                        :disabled="isActiveOnlyView || !hasHistoricBefore"
                        :readonly="isActiveOnlyView || !hasHistoricBefore"
                      />
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-slider v-model="editedItem.metaEconomia"
                        :label="editedItem.metaEconomia + ' ' + averageLine.name" :thumb-color="averageLine.color"
                        thumb-label="always" :disabled="isActiveOnlyView || !hasHistoricBefore"
                        :readonly="isActiveOnlyView || !hasHistoricBefore" min="0" max="100"></v-slider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        outlined
                        dense
                        type="month"
                        label="Mês inicial"
                        v-model="baselineConfigValidFrom"
                        :min="baselineConfigMinDate"
                        :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                        :disabled="isActiveOnlyView || !hasHistoricBefore"
                        :readonly="isActiveOnlyView || !hasHistoricBefore"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        outlined
                        dense
                        type="month"
                        label="Mês final"
                        v-model="baselineConfigValidTo"
                        :min="baselineConfigValidToMinDate"
                        :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                        :disabled="isActiveOnlyView || !hasHistoricBefore"
                        :readonly="isActiveOnlyView || !hasHistoricBefore"
                      />
                    </v-col>
                  </v-row>
                  <v-divider style="margin-top: 8px;" />
                  <v-row dense style="padding: 8px 12px 12px 12px;">
                    <v-col cols="12">
                      <v-switch
                        v-model="editedItem.driverOptions.isEnabled"
                        label="Usar driver de referência"
                        dense
                        inset
                        :disabled="isActiveOnlyView || !hasHistoricBefore"
                        :readonly="isActiveOnlyView || !hasHistoricBefore"
                      />
                    </v-col>

                    <template v-if="isDriverEnabled">
                      <v-col cols="12" md="4">
                        <v-select
                          outlined
                          dense
                          :items="driverTypeOptions"
                          item-text="text"
                          item-value="value"
                          label="Tipo do Driver"
                          v-model="editedItem.driverOptions.driverType"
                          :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                          :disabled="isActiveOnlyView || !hasHistoricBefore"
                          :readonly="isActiveOnlyView || !hasHistoricBefore"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          outlined
                          dense
                          label="Rótulo do Driver"
                          v-model="editedItem.driverOptions.driverLabel"
                          :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                          :disabled="isActiveOnlyView || !hasHistoricBefore"
                          :readonly="isActiveOnlyView || !hasHistoricBefore"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          outlined
                          dense
                          label="Unidade do Driver"
                          v-model="editedItem.driverOptions.driverUnitLabel"
                          :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                          :disabled="isActiveOnlyView || !hasHistoricBefore"
                          :readonly="isActiveOnlyView || !hasHistoricBefore"
                        />
                      </v-col>
                    </template>

                    <template v-if="isFixedBaselineMode">
                      <v-col cols="12">
                        <h3 style="color: grey; font-size: 16px; margin-bottom: 4px;">Baseline Fixo</h3>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          outlined
                          dense
                          type="number"
                          min="0.01"
                          label="Água"
                          suffix="m³"
                          v-model="editedItem.fixedBaselineWater"
                          :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                          :disabled="isActiveOnlyView || !hasHistoricBefore"
                          :readonly="isActiveOnlyView || !hasHistoricBefore"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          outlined
                          dense
                          type="number"
                          min="0.01"
                          label="Esgoto"
                          suffix="m³"
                          v-model="editedItem.fixedBaselineSewer"
                          :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                          :disabled="isActiveOnlyView || !hasHistoricBefore"
                          :readonly="isActiveOnlyView || !hasHistoricBefore"
                        />
                      </v-col>
                      <v-col cols="12" md="4" v-if="isDriverEnabled">
                        <v-text-field
                          outlined
                          dense
                          type="number"
                          :label="editedItem.driverOptions.driverLabel || 'Valor de Referência do Driver'"
                          :suffix="editedItem.driverOptions.driverUnitLabel || ''"
                          v-model="editedItem.driverOptions.driverReferenceValue"
                          :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                          :disabled="isActiveOnlyView || !hasHistoricBefore"
                          :readonly="isActiveOnlyView || !hasHistoricBefore"
                        />
                      </v-col>
                    </template>

                    <template v-if="isMonthlyBaselineMode">
                      <v-col cols="12">
                        <h3 style="color: grey; font-size: 16px; margin-bottom: 4px;">Baseline Mensal</h3>
                      </v-col>
                      <v-col
                        cols="12"
                        v-for="month in monthOptions"
                        :key="month.value"
                        style="margin-bottom: 12px;"
                      >
                        <v-card outlined style="padding: 12px;">
                          <h4 style="color: grey; margin-bottom: 12px;">{{ month.text }}</h4>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-text-field
                                outlined
                                type="number"
                                min="0.01"
                                label="Água de Referência"
                                suffix="m³"
                                v-model="editedItem.monthlyBaseline[month.value].water"
                                :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                                :disabled="isActiveOnlyView || !hasHistoricBefore"
                                :readonly="isActiveOnlyView || !hasHistoricBefore"
                              />
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field
                                outlined
                                type="number"
                                min="0.01"
                                label="Esgoto de Referência"
                                suffix="m³"
                                v-model="editedItem.monthlyBaseline[month.value].sewer"
                                :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                                :disabled="isActiveOnlyView || !hasHistoricBefore"
                                :readonly="isActiveOnlyView || !hasHistoricBefore"
                              />
                            </v-col>
                            <v-col cols="12" md="4" v-if="isDriverEnabled">
                              <v-text-field
                                outlined
                                type="number"
                                :label="editedItem.driverOptions.driverLabel || 'Valor de Referência do Driver'"
                                :suffix="editedItem.driverOptions.driverUnitLabel || ''"
                                v-model="editedItem.monthlyBaseline[month.value].driverReferenceValue"
                                :rules="hasHistoricBefore && !isActiveOnlyView ? rulesRequired : []"
                                :disabled="isActiveOnlyView || !hasHistoricBefore"
                                :readonly="isActiveOnlyView || !hasHistoricBefore"
                              />
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </template>
                  </v-row>
                  </template>
                </v-col>
              </v-row>


            </v-tab-item>
            <v-tab-item key="7">
              <Alerts
                v-if="editedItem && editedItem.id"
                :id_unit="editedItem.id"
                :unit="editedItem"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showUnitSaveButton" @click="save" :loading="saveButtonLoading" text :disabled="isActiveOnlyView || !validForm"
            color="primary">
            Salvar
          </v-btn>
        </v-card-actions>
        <v-overlay absolute v-model="saveButtonLoading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-dialog v-model="baselineFormDialog" max-width="1100">
      <v-card>
        <v-card-title class="primary lighten white--text">
          {{ baselineFormTitle }}
          <v-spacer></v-spacer>
          <v-btn text class="white--text" @click="closeBaselineForm">
            <v-icon white>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding-top: 16px;">
          <v-row style="margin-top: 12px; padding: 0 12px;">
            <v-col cols="12" md="4">
              <v-select
                outlined
                :items="referenceModeOptions"
                item-text="text"
                item-value="value"
                label="Modo de Referência"
                v-model="baselineForm.referenceMode"
                :disabled="baselineFormMode === 'view'"
                :readonly="baselineFormMode === 'view'"
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-slider
                v-model="baselineForm.metaEconomia"
                :label="baselineForm.metaEconomia + ' ' + averageLine.name"
                :thumb-color="averageLine.color"
                thumb-label="always"
                :disabled="baselineFormMode === 'view'"
                :readonly="baselineFormMode === 'view'"
                min="0"
                max="100"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                dense
                type="month"
                label="Mês inicial"
                v-model="baselineForm.validFrom"
                :min="baselineConfigMinDate"
                :disabled="baselineFormMode === 'view'"
                :readonly="baselineFormMode === 'view'"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                dense
                type="month"
                label="Mês final"
                v-model="baselineForm.validTo"
                :min="baselineConfigValidToMinDate"
                :disabled="baselineFormMode === 'view'"
                :readonly="baselineFormMode === 'view'"
              />
            </v-col>
          </v-row>
          <v-divider style="margin-top: 8px;" />
          <v-row dense style="padding: 8px 12px 12px 12px;">
            <v-col cols="12">
              <v-switch
                v-model="baselineForm.driverOptions.isEnabled"
                label="Usar driver de referência"
                dense
                inset
                :disabled="baselineFormMode === 'view'"
                :readonly="baselineFormMode === 'view'"
              />
            </v-col>

            <template v-if="isBaselineDriverEnabled">
              <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                <v-select
                  outlined
                  dense
                  :items="driverTypeOptions"
                  item-text="text"
                  item-value="value"
                  label="Tipo do Driver"
                  v-model="baselineForm.driverOptions.driverType"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
              <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                <v-text-field
                  outlined
                  dense
                  label="Rótulo do Driver"
                  v-model="baselineForm.driverOptions.driverLabel"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
              <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                <v-text-field
                  outlined
                  dense
                  label="Unidade do Driver"
                  v-model="baselineForm.driverOptions.driverUnitLabel"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
            </template>

            <template v-if="isBaselineFixedMode">
              <v-col cols="12">
                <h3 style="color: grey; font-size: 16px; margin-bottom: 4px;">Baseline Fixo</h3>
              </v-col>
              <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  min="0.01"
                  label="Água"
                  suffix="m³"
                  v-model="baselineForm.fixedBaselineWater"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  min="0.01"
                  label="Esgoto"
                  suffix="m³"
                  v-model="baselineForm.fixedBaselineSewer"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
              <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  min="0.01"
                  label="Referência monetária"
                  prefix="R$"
                  v-model="baselineForm.fixedBaselineReferenceEconomy"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="isBaselineDriverEnabled">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  :label="baselineForm.driverOptions.driverLabel || 'Valor de Referência do Driver'"
                  :suffix="baselineForm.driverOptions.driverUnitLabel || ''"
                  v-model="baselineForm.driverOptions.driverReferenceValue"
                  :disabled="baselineFormMode === 'view'"
                  :readonly="baselineFormMode === 'view'"
                />
              </v-col>
            </template>

            <template v-if="isBaselineMonthlyMode">
              <v-col cols="12">
                <h3 style="color: grey; font-size: 16px; margin-bottom: 4px;">Baseline Mensal</h3>
              </v-col>
              <v-col
                cols="12"
                v-for="month in monthOptions"
                :key="month.value"
                style="margin-bottom: 12px;"
              >
                <v-card outlined style="padding: 12px;">
                  <h4 style="color: grey; margin-bottom: 12px;">{{ month.text }}</h4>
                  <v-row>
                    <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        min="0.01"
                        label="Água de Referência"
                        suffix="m³"
                        v-model="baselineForm.monthlyBaseline[month.value].water"
                        :disabled="baselineFormMode === 'view'"
                        :readonly="baselineFormMode === 'view'"
                      />
                    </v-col>
                    <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        min="0.01"
                        label="Esgoto de Referência"
                        suffix="m³"
                        v-model="baselineForm.monthlyBaseline[month.value].sewer"
                        :disabled="baselineFormMode === 'view'"
                        :readonly="baselineFormMode === 'view'"
                      />
                    </v-col>
                    <v-col cols="12" :md="isBaselineDriverEnabled ? 3 : 4">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        min="0.01"
                        label="Referência monetária"
                        prefix="R$"
                        v-model="baselineForm.monthlyBaseline[month.value].reference_economy"
                        :disabled="baselineFormMode === 'view'"
                        :readonly="baselineFormMode === 'view'"
                      />
                    </v-col>
                    <v-col cols="12" md="3" v-if="isBaselineDriverEnabled">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        :label="baselineForm.driverOptions.driverLabel || 'Valor de Referência do Driver'"
                        :suffix="baselineForm.driverOptions.driverUnitLabel || ''"
                        v-model="baselineForm.monthlyBaseline[month.value].driverReferenceValue"
                        :disabled="baselineFormMode === 'view'"
                        :readonly="baselineFormMode === 'view'"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeBaselineForm">
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="baselineFormLoading"
            :disabled="baselineFormMode === 'view'"
            @click="saveBaselineForm"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="monthlyBaselineViewDialog" max-width="980">
      <v-card>
        <v-card-title class="primary lighten white--text">
          Distribuição da baseline mensal
          <v-spacer></v-spacer>
          <v-btn text class="white--text" @click="closeMonthlyBaselineView">
            <v-icon white>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding-top: 16px;" v-if="monthlyBaselineViewConfig">
          <v-row>
            <v-col cols="12" md="4">
              <v-card outlined class="baseline-summary-card baseline-summary-card--primary">
                <v-card-text class="baseline-summary-card__content">
                  <div class="baseline-card-label">Meta de economia</div>
                  <div class="baseline-card-emphasis">{{ monthlyBaselineViewConfig.metaEconomia }}%</div>
                  <div class="baseline-card-label" style="margin-top: 12px;">Validade</div>
                  <div class="baseline-card-value">
                    {{ formatBaselineDate(monthlyBaselineViewConfig.validFrom) }} até {{ formatBaselineDate(monthlyBaselineViewConfig.validTo) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="baseline-summary-card">
                <v-card-text class="baseline-summary-card__content">
                  <div class="baseline-card-label">Driver</div>
                  <template v-if="monthlyBaselineViewConfig.driver && monthlyBaselineViewConfig.driver.isEnabled">
                    <div class="baseline-card-value">{{ getDriverTypeText(monthlyBaselineViewConfig.driver.driverType) }}</div>
                    <div class="baseline-card-support">Rotulo: {{ monthlyBaselineViewConfig.driver.driverLabel || '-' }}</div>
                    <div class="baseline-card-support">Unidade: {{ monthlyBaselineViewConfig.driver.driverUnitLabel || '-' }}</div>
                  </template>
                  <template v-else>
                    <div class="baseline-card-value">Sem driver configurado</div>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="baseline-summary-card">
                <v-card-text class="baseline-summary-card__content">
                  <div class="baseline-card-label">Criada em</div>
                  <div class="baseline-card-value">{{ formatBaselineDateTime(monthlyBaselineViewConfig.createdAt) }}</div>
                  <div class="baseline-card-label" style="margin-top: 12px;">Modo</div>
                  <div class="baseline-card-chip">{{ getBaselineModeText(monthlyBaselineViewConfig.referenceMode) }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-card outlined class="baseline-history-card baseline-monthly-view-card">
            <v-card-text class="baseline-history-card__content">
              <div class="baseline-card-label">Distribuicao mensal</div>
              <div class="baseline-monthly-grid">
                <v-card
                  v-for="month in monthOptions"
                  :key="month.value"
                  outlined
                  class="baseline-month-card"
                >
                  <v-card-text class="baseline-month-card__content">
                    <div class="baseline-month-card__title">{{ month.text }}</div>
                    <div class="baseline-month-card__metric">
                      <span class="baseline-month-card__metric-label">Agua</span>
                      <span class="baseline-month-card__metric-value">{{ monthlyBaselineViewConfig.monthlyBaseline[month.value].water != null ? monthlyBaselineViewConfig.monthlyBaseline[month.value].water : '-' }}</span>
                      <span class="baseline-month-card__metric-unit">m³</span>
                    </div>
                    <div class="baseline-month-card__metric">
                      <span class="baseline-month-card__metric-label">Esgoto</span>
                      <span class="baseline-month-card__metric-value">{{ monthlyBaselineViewConfig.monthlyBaseline[month.value].sewer != null ? monthlyBaselineViewConfig.monthlyBaseline[month.value].sewer : '-' }}</span>
                      <span class="baseline-month-card__metric-unit">m³</span>
                    </div>
                    <div class="baseline-month-card__metric">
                      <span class="baseline-month-card__metric-label">Ref. monetaria</span>
                      <span class="baseline-month-card__metric-value">{{ monthlyBaselineViewConfig.monthlyBaseline[month.value].reference_economy != null ? monthlyBaselineViewConfig.monthlyBaseline[month.value].reference_economy : '-' }}</span>
                      <span class="baseline-month-card__metric-unit">R$</span>
                    </div>
                    <div
                      v-if="monthlyBaselineViewConfig.driver && monthlyBaselineViewConfig.driver.isEnabled"
                      class="baseline-month-card__metric"
                    >
                      <span class="baseline-month-card__metric-label">{{ monthlyBaselineViewConfig.driver.driverLabel || 'Driver' }}</span>
                      <span class="baseline-month-card__metric-value">{{ monthlyBaselineViewConfig.monthlyBaseline[month.value].driverReferenceValue != null ? monthlyBaselineViewConfig.monthlyBaseline[month.value].driverReferenceValue : '-' }}</span>
                      <span class="baseline-month-card__metric-unit">{{ monthlyBaselineViewConfig.driver.driverUnitLabel || '' }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeMonthlyBaselineView">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeHistoricoDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          Confirma a remoção?
        </v-card-title>
        <v-card-text>
          O histórico será removido caso confirme
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="removeHistoricoDialog = false">
            <v-icon white>mdi-window-close</v-icon>

          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="removeHistorico()">
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <date-picker-dialog title="Escolha a data de instalação" type="month" :show="dataMediaHistoricoDialog"
      @close="status => dataMediaHistoricoDialog = status" :input="editedItem.dataMediaHistorico"
      @change="newDate => editedItem.dataMediaHistorico = newDate" />

  </v-container>
</template>

<script>
import UnitScript from './UnitsScript';
export default UnitScript;
</script>


<style scoped>
.title-displays {
  font-size: 25px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.units-table-names {
  white-space: normal;
  font-size: 12px;
  font-weight: bold;
}

.meta-kpi-card {
  height: 100%;
  border-radius: 16px;
  border-color: rgba(25, 118, 210, 0.18) !important;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(244, 249, 255, 0.94) 100%);
  box-shadow: 0 10px 24px rgba(24, 53, 92, 0.06);
}

.meta-kpi-card--primary {
  background:
    linear-gradient(135deg, rgba(25, 118, 210, 0.12) 0%, rgba(255, 255, 255, 0.98) 55%, rgba(229, 242, 255, 0.96) 100%);
  border-color: rgba(25, 118, 210, 0.28) !important;
}

.meta-kpi-card__content {
  padding: 18px 18px 16px !important;
}

.meta-kpi-card__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6f7f90;
  font-weight: 700;
}

.meta-kpi-card__value-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 12px;
}

.meta-kpi-card__unit {
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  color: #5f7284;
}

.meta-kpi-card__value {
  font-size: 30px;
  line-height: 1;
  font-weight: 800;
  color: #16324f;
}

.meta-kpi-card__support {
  margin-top: 10px;
  font-size: 13px;
  line-height: 1.4;
  color: #617181;
}

.baseline-summary-row {
  padding: 14px 12px 16px;
}

.baseline-summary-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.baseline-summary-card {
  height: 100%;
  border-radius: 16px;
  border-color: rgba(25, 118, 210, 0.18) !important;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(244, 249, 255, 0.94) 100%);
  box-shadow: 0 10px 24px rgba(24, 53, 92, 0.06);
}

.baseline-summary-card--primary {
  background:
    linear-gradient(135deg, rgba(25, 118, 210, 0.12) 0%, rgba(255, 255, 255, 0.98) 55%, rgba(229, 242, 255, 0.96) 100%);
  border-color: rgba(25, 118, 210, 0.28) !important;
}

.baseline-summary-card__content {
  padding: 18px 18px 16px !important;
}

.baseline-card-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6f7f90;
  font-weight: 700;
}

.baseline-card-chip {
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(25, 118, 210, 0.1);
  color: #155a9c;
  font-size: 12px;
  font-weight: 700;
}

.baseline-card-emphasis {
  margin-top: 14px;
  font-size: 34px;
  line-height: 1;
  font-weight: 800;
  color: #16324f;
}

.baseline-card-caption {
  margin-top: 6px;
  font-size: 13px;
  color: #617181;
}

.baseline-card-value {
  margin-top: 8px;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 700;
  color: #253648;
}

.baseline-card-value--lg {
  font-size: 18px;
}

.baseline-card-support {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.4;
  color: #617181;
}

.baseline-metric-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.baseline-metric-box {
  padding: 12px 10px;
  border-radius: 14px;
  background: rgba(25, 118, 210, 0.06);
  border: 1px solid rgba(25, 118, 210, 0.1);
  text-align: center;
}

.baseline-metric-box__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6f7f90;
  font-weight: 700;
}

.baseline-metric-box__value {
  margin-top: 6px;
  font-size: 24px;
  line-height: 1;
  font-weight: 800;
  color: #16324f;
}

.baseline-metric-box__unit {
  margin-top: 4px;
  font-size: 11px;
  color: #708191;
  font-weight: 600;
}

.baseline-driver-reference {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(18, 54, 96, 0.04);
  border: 1px solid rgba(25, 118, 210, 0.12);
}

.baseline-driver-reference__value {
  font-size: 22px;
  line-height: 1.1;
  font-weight: 800;
  color: #16324f;
}

.baseline-driver-reference__name {
  margin-top: 6px;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 700;
  color: #253648;
}

.baseline-driver-reference__value-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 6px;
}

.baseline-driver-reference__unit {
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
  color: #617181;
}

.baseline-driver-reference__meta {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
  color: #617181;
}

.baseline-empty-card {
  border-radius: 14px;
  border-color: rgba(25, 118, 210, 0.15) !important;
  background: rgba(255, 255, 255, 0.82);
}

.baseline-empty-text {
  color: #596a7b;
  font-weight: 600;
  padding: 16px !important;
}

.baseline-history-card {
  margin-top: 4px;
  border-radius: 16px;
  border-color: rgba(25, 118, 210, 0.18) !important;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 22px rgba(24, 53, 92, 0.05);
}

.baseline-history-card__content {
  padding: 16px 16px 8px !important;
}

.baseline-monthly-action {
  margin-top: 12px;
  padding-left: 0 !important;
}

.baseline-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.baseline-history-title {
  margin-top: 4px;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  color: #233649;
}

.baseline-history-table {
  border-radius: 12px;
  overflow: hidden;
}

.baseline-monthly-view-card {
  margin-top: 16px;
}

.baseline-monthly-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 10px;
}

.baseline-month-card {
  border-radius: 14px;
  border-color: rgba(25, 118, 210, 0.14) !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(247, 250, 255, 0.94) 100%);
}

.baseline-month-card__content {
  padding: 14px !important;
}

.baseline-month-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #233649;
  margin-bottom: 10px;
}

.baseline-month-card__metric {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.baseline-month-card__metric-label {
  min-width: 56px;
  font-size: 12px;
  font-weight: 700;
  color: #6f7f90;
}

.baseline-month-card__metric-value {
  font-size: 18px;
  line-height: 1;
  font-weight: 800;
  color: #16324f;
}

.baseline-month-card__metric-unit {
  font-size: 12px;
  font-weight: 700;
  color: #617181;
}

@media (max-width: 960px) {
  .meta-kpi-card__content {
    padding: 16px !important;
  }

  .meta-kpi-card__value {
    font-size: 28px;
  }

  .baseline-summary-card__content {
    padding: 16px !important;
  }

  .baseline-card-emphasis {
    font-size: 30px;
  }

  .baseline-history-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .baseline-monthly-grid {
    grid-template-columns: 1fr;
  }
}

tbody,
tr:nth-child(even) {
  background: rgba(25, 118, 210, .08) !important
}

tbody,
tr:nth-child(odd) {
  background: white !important
}
</style>
